import Icon from './Icon'
import { COUNTED_CHANNELS } from '../lib/chase'

/**
 * How many times we've chased, small enough to sit in a table cell.
 *
 * WhatsApp and email — see `COUNTED_CHANNELS`. The phone chip sat at zero on
 * every row because no call is logged from this screen; a column that is
 * always empty teaches the reader to stop looking at it.
 */
export default function ChaseChips({ counts = {}, size = 11, onWhatsApp, onEmail }) {
  // Both real channels open the same thread — the drawer is not filtered per
  // channel, it already reads every attempt regardless of which one made it.
  const OPENS = { WHATSAPP: onWhatsApp, EMAIL: onEmail }

  return (
    <span className="chips">
      {COUNTED_CHANNELS.map((c) => {
        const n = counts?.[c.key] ?? 0

        // The chip is the way into the chat tray — clicking it opens the
        // thread, while clicking the row opens the ledgers. `stopPropagation`
        // keeps the two apart, and a real <button> keeps it reachable by keyboard.
        const onOpen = OPENS[c.key]
        const className = `chip ${c.cls} ${n > 0 ? 'hot' : 'cold'}${onOpen ? ' chip-btn' : ''}`
        const title = onOpen
          ? `Open the ${c.label} thread`
          : `${c.label}: ${n === 0 ? 'never' : `${n} time${n === 1 ? '' : 's'}`}`

        if (onOpen) {
          return (
            <button
              key={c.key}
              type="button"
              className={className}
              title={title}
              onClick={(e) => {
                e.stopPropagation()
                onOpen()
              }}
            >
              <Icon name={c.icon} size={size} />
              {n}
            </button>
          )
        }

        return (
          <span key={c.key} className={className} title={title}>
            <Icon name={c.icon} size={size} />
            {n}
          </span>
        )
      })}
    </span>
  )
}
